import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  searchQuery: "",
  countryData: null,
  searchResults: [],
  searchCount: 0,
  worldBoxToken: "cURWUGVhQXpnTHNHVFp2YkMvLzoxbEQ+ODlSbm5SUyTCoyorJw==",
  companySelectedByUser: localStorage.getItem("userSelectedCompany")
    ? JSON.parse(localStorage.getItem("userSelectedCompany"))
    : null,
};

const searchSlice = createSlice({
  name: "search",
  initialState,
  reducers: {
    setSearch: (state, action) => {
      state.searchQuery = action.payload;
    },
    setCountryData: (state, action) => {
      state.countryData = action.payload;
    },
    setSearchResults: (state, action) => {
      state.searchResults = action.payload;
    },
    setSearchCount: (state, action) => {
      state.searchCount = action.payload;
    },
    setCompany: (state, action) => {
      state.companySelectedByUser = action.payload;
      localStorage.setItem(
        "userSelectedCompany",
        JSON.stringify(action.payload)
      );
    },
  },
});

export const {
  setSearch,
  setSearchResults,
  setSearchCount,
  setCompany,
  setCountryData,
} = searchSlice.actions;

export default searchSlice.reducer;
